module.exports = __webpack_public_path__ + "9d3edf8c3a0c9fcd634d2353e61ce348.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/xinshang/xinshang-title.png
// module id = 1236
// module chunks = 0